'use strict';

var $ 	= require('jquery');
var config = require('../utils/config.js');
var logger = require('../utils/logger.js');



const classNames = {
	eu: 'eu',
	privacySettings: 'privacy-settings',
	us: 'us'
};

module.exports = {
	init: function (consentType) {
		const $euPrivacy = $.findByBem(classNames.privacySettings, null, classNames.eu);
		const $usPrivacy = $.findByBem(classNames.privacySettings, null, classNames.us);

		if (consentType === 'gdpr') {
			$euPrivacy.show();
	
			$euPrivacy.on('click.footer', function (e) {
				e.preventDefault();
				if (window._sp_ && window._sp_.gdpr.loadPrivacyManagerModal) {
					window._sp_.gdpr.loadPrivacyManagerModal(config.euPrivacyManagerId);
				} else {
					logger.debug('CMP: Sourcepoint privacy manager script not loaded');
				}			
			});
	
		} else if (consentType === 'usnat') {
			$usPrivacy.show();
	
			$usPrivacy.on('click.footer', function (e) {
				e.preventDefault();
				if (window._sp_ && window._sp_.usnat.loadPrivacyManagerModal) {
					window._sp_.usnat.loadPrivacyManagerModal(config.usPrivacyManagerId);
				} else {
					logger.debug('CMP: Sourcepoint privacy manager script not loaded');
				}
			});
	
		} else {
			logger.debug('Consent type not found — hiding both links.');
		}
	}
};
